import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrivacyPolicyPopupComponent } from 'src/app/popups/privacy-policy-popup/privacy-policy-popup.component';
import { TermsAndConditionsPopupComponent } from 'src/app/popups/terms-and-conditions-popup/terms-and-conditions-popup.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  public isLoginStatus: boolean;
  public closeResult: string;

  currentYear: number = new Date().getFullYear();

  public constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly modalService: NgbModal
  ) {}

  public userAuthenticate(): void {
    this.isLoginStatus = this.authService.isAuthenticated();
    // this.authService.getUserData().subscribe((data) => {
    //   console.log(data);
    //   if (data) {
    //     this.user = JSON.parse(data);
    //   }
    // });
  }

  public openTermsConditionsPopup() {
    const modalRef = this.modalService.open(TermsAndConditionsPopupComponent, {
      ariaLabelledBy:  'Terms-Conditions-Popup-Id',
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.result.then(
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  public openPrivacyPolicyPopup() {
    const modalRef = this.modalService.open(PrivacyPolicyPopupComponent, {
      ariaLabelledBy:  'Privay-Policy-Popup-Id',
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.result.then(
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public logout() {
    this.router.navigate(['']);
    const logout = this.authService.logout();
    if (logout) {
      location.reload();

      return false;
    }

    return true;
  }

  ngOnInit(): void {
    this.userAuthenticate();
  }
}
